<div class="flex flex-row">
  <button #filterTrigger [matMenuTriggerFor]="menu" class="flex justify-between items-center filter-class mat-body-2 fw-700 w-240 white-bg"
          mat-button>
    <span class="mr-auto">{{ 'INSPIRATION_LOUNGE.LOUNGE.FILTER' | transloco }}</span>
    <mat-icon svgIcon="expand_more" class="ml-auto mr-8 mt-4"></mat-icon>
  </button>
  <mat-menu #menu="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16">
    <div class="flex flex-row">
      <div class="mat-body mr-18">{{selectedCount}} </div>
      <span class="mat-body">{{ 'INSPIRATION_LOUNGE.LOUNGE.SELECTED' | transloco }}</span>
    </div>
    <mat-divider class="divider mt-2 mb-10"></mat-divider>
    <div class="flex flex-col overflow-class pr-10">
      <div *ngFor="let filterGroup of filterGroups; let i = index" class="flex flex-col">
        <span (click)="selectFilterTypes(filterItem, $event)" (title)="filterItem.name"
              *ngFor="let filterItem of filterGroup.items" class="field-filter-row cursor-pointer justify-between items-center w-100-percent pl-6 pr-6">
          <mat-icon [svgIcon]="filterItem.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md"></mat-icon>
          <button class="mr-auto" mat-menu-item>{{filterItem.name}}</button>
          <span> {{filterItem.count }}</span>
        </span>
        <mat-divider *ngIf="i < filterGroups.length - 1" class="divider mt-6 mb-10"></mat-divider>
      </div>
      <span class="flex-auto mb-10"></span>
    </div>
    <mat-divider class="divider mt-6 mb-10"></mat-divider>
    <div class="flex flex-row gap-x-4" dir="rtl">
      <button (click)="applyFilter()" class="accent" type="button">{{'BUTTONS.APPLY' | transloco}}</button>
      <button (click)="resetFilter()" class="white mr-40" type="button">{{'BUTTONS.CLEAR' | transloco}}</button>
    </div>
  </mat-menu>

  <div class="flex flex-row">
    <div class="flex flex-row flex-wrap">
      <div *ngFor="let filterItem of selectedItems" class="flex items-center item btn-font-rounded ml-24 mb-16">
        {{filterItem.name}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="filterItem.selected = false; applyFilter()"></mat-icon>
      </div>
    </div>
  </div>
</div>
